import MenuHeader from '../../common/MenuHeader'
import RightGoogleMap from '../../common/RightGoogleMap'
import SetUpLayout from '../../common/SetUpLayout'
import LayoutMain from './LayoutMain'
import useTranslation from '@/hooks/useTranslation'

type Props = {}

const ET = (props: Props) => {
  const { t } = useTranslation()
  
  return (
    <SetUpLayout
      title={ t('formsLabelsMicroClimate') }
      header={<MenuHeader />}
      rightLayout={
        <RightGoogleMap
          style={{
            width: { xs: '488px' },
          }}
        />
      }
    >
      <LayoutMain title="Data 9 of 9" subtitle={ t('formsLabelsMicroClimate') } />
    </SetUpLayout>
  )
}

export default ET
